export default __webpack_public_path__ + "static/media/icon_pst_Cpp.bdeb964a.svg";